<template>
    <div class="private-products">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="privateProducts"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
            @filterMethod="filterMethod"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    align="center"
                ></el-table-column>
                <el-table-column align="center" width="100" label="Image">
                    <template slot-scope="scope">
                        <el-image
                            class="elImage_show"
                            style="height: 80px; width: 80px"
                            fit="fill"
                            :src="scope.row.image && scope.row.image.url"
                            :preview-src-list="[
                                scope.row.image && scope.row.image.url,
                            ]"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                            <div slot="placeholder" class="image-slot">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    property="goods_name"
                    align="left"
                    label="Product Info"
                >
                    <template slot-scope="scope">
                        <div class="tbItem">
                            <div
                                class="goods-name ellipsis-2"
                                @click="toGoodsDetail(scope.row)"
                            >
                                {{ scope.row.good.goods_name }}
                            </div>
                            <div>SKU:&nbsp;{{ scope.row.sku }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Category"
                    prop="goods_category.name_en"
                    width="150"
                >
                    <template
                        slot-scope="scoped"
                        v-if="
                            scoped.row.good.catalog_names &&
                            scoped.row.good.catalog_names.length > 0
                        "
                    >
                        <div
                            v-for="item of scoped.row.good.catalog_names"
                            :key="item.name"
                        >
                            {{ item.name_en }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Price"
                    prop="price"
                    width="150"
                >
                    <template slot-scope="scope">
                        <div>${{ scope.row.price }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Attribute"
                    prop="value"
                    width="200"
                >
                    <template slot-scope="scope">
                        <!-- <div v-for="(item) in scope.row.value.split(',')" :key="item"> -->
                        <el-tag
                            v-for="item in scope.row.value.split(',')"
                            :key="item"
                            >{{ item }}</el-tag
                        >
                        <!-- </div> -->
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Customer"
                    prop="Customer"
                    width="200"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <!-- <div v-for="item in scope.row.user_email" :key="item">
                            {{item}}
                        </div> -->
                        <div>
                            {{ scope.row.user_email.toString() }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Created On"
                    prop="created_at"
                    width="150"
                ></el-table-column>
                <el-table-column label="Operation" align="left" width="150">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
            :treeData="treeData"
            :goodsTagList="goodsTagList"
        ></detail>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import detail from "@/views/pages/admin/productsSetList/detail.vue";
export default {
    // 有些表格的相同部分 , 抽离在了tableMixins混合器里面
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Product Name、SKU",
            searchForm: {
                email: "",
            },
            searchForm_transfer: {
                email: "",
            },
            funcName: "privateProducts",
            detailVisible: false,
            selectList: [],
            advanceSearchFields: {
                email: {
                    label: "Email",
                    type: "filterSelect",
                    options: [],
                },
            },
            treeData: [],
            goodsTagList: [],
        };
    },
    methods: {
        filterMethod(val) {
            console.log("privateProducts: ", val);
            cmofferApi.userSelect({ keyword: val }, "get").then((res) => {
                if (res) {
                    console.log(res);
                    let arr = [];
                    res.data.forEach(item=>{
                        arr.push({
                            label: item.email,
                            value: item.id
                        });
                    })
                    this.advanceSearchFields.email.options = arr;
                }
            });
        },
        /**
         * 产品新增
         */
        add() {
            this.addVisible = true;
        },
        // 获取下载列表
        privateProducts(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .privateProducts(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.closeDrawer();
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "detail") {
                    // row 的id不是产品的id, goods_id才是产品的id
                    this.tableItem.id = row.goods_id;
                    this.detailVisible = true;
                } else if (item.funcName == "edit") {
                    this.editVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.privateProducts();
            this.goodsCategory();
            this.goodsTagsSelect();
        },
        // 跳转到商品详情
        toGoodsDetail(item) {
            this.$router.push({
                path: `/goodsList/detail`,
                query: {
                    id: item.goods_id,
                },
            });
        },
        // 分类树
        goodsCategory() {
            cmofferApi.goodsCategory({}, "get").then((res) => {
                if (res) {
                    this.treeData = res.data;
                }
            });
        },
        // 分类标签
        goodsTagsSelect() {
            cmofferApi.goodsTagsSelect({}, "get").then((res) => {
                if (res) {
                    this.goodsTagList = res.data;
                }
            });
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        detail,
    },
    computed: {
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
                {
                    label: this.$i18n.locale == "zh" ? "邮箱" : "Email",
                    key: "email",
                    type: "filterSelect",
                    props: {
                        list: this.advanceSearchFields.email.options,
                        nameKey: "label",
                        valueKey: "value",
                    },
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.private-products {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
        .el-tag {
            margin-top: 5px;
            & + .el-tag {
                margin-top: 5px;
            }
        }
    }
    .goods-name {
        color: $color-333333;
        font-weight: bold;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
    .font-bold {
        font-weight: bold;
    }
}
</style>
